







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import Icon from '@/main-components/common/Icon.vue';

@Component({
  components: { BeatLoader, Icon },
})
export default class MainButton extends Vue {
  @Prop({ default: 'Primary Button' })
  label: string;

  @Prop({ default: true })
  isPrimary: boolean;

  @Prop({ default: true })
  isPrimaryColor: boolean;

  @Prop({ default: false })
  isLightColor: boolean;

  @Prop()
  isLoading: boolean;

  @Prop({ default: false })
  isDisable: boolean;

  @Prop({ default: false })
  isFullLength: boolean;

  @Prop({ default: null })
  icon: string | null;

  @Prop({ default: 14 })
  iconHeight: number;

  @Prop({ default: 14 })
  iconWidth: number;

  @Prop({ default: true })
  isIconFill: boolean;

  @Prop({ default: false })
  isBadge: boolean;

  @Prop({ default: false })
  isIconOnly: boolean;

  @Prop({ default: '' })
  customClass: string;

  @Prop({ default: null })
  onButtonClick!: () => Promise<void> | null;

  isButtonLoading = false;
  isHovering = false;

  get buttonClass() {
    // NOTE: Check tailwind.scss for these css classess
    let buttonClass = this.isPrimary ? 'primary' : 'secondary';

    buttonClass += this.isLightColor
      ? ' light'
      : this.isPrimaryColor
      ? ' brand'
      : ' black';

    buttonClass += this.isFullLength ? ' w-full' : '';
    buttonClass += this.isDisable ? ' disable' : '';
    buttonClass += this.isBadge ? ' badge' : '';
    return buttonClass + ' relative' + this.customClass;
  }

  get currentColor() {
    if (this.isPrimary) {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-white-primary',
      );
      // NOTE: color for ghost button
    } else if (this.isPrimaryColor) {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-brand-dark-primary',
      );
    } else {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-black-primary',
      );
    }
  }

  get currentHoverColor() {
    if (this.isPrimary) {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-white-primary',
      );
      // NOTE: color for ghost button
    } else if (this.isPrimaryColor) {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-brand-dark-secondary',
      );
    } else {
      return getComputedStyle(document.body).getPropertyValue(
        '--color-black-secondary',
      );
    }
  }

  get loadingIconColor() {
    return this.currentColor;
  }

  get iconColor() {
    if (this.isDisable) {
      if (this.isPrimary) {
        return getComputedStyle(document.body).getPropertyValue(
          '--color-white-primary',
        );
      } else {
        return getComputedStyle(document.body).getPropertyValue(
          '--color-gray-dark-tertiary',
        );
      }
    } else {
      return this.currentColor;
    }
  }

  get iconHoverColor() {
    return this.currentHoverColor;
  }

  created() {
    if (this.isLoading) {
      this.isButtonLoading = this.isLoading;
    }
  }

  @Watch('isLoading')
  isLoadingChange() {
    this.isButtonLoading = this.isLoading;
  }

  async onButtonClicked() {
    if (this.isButtonLoading || this.isLoading || this.isDisable) return;

    if (this.onButtonClick) {
      this.isButtonLoading = true;
      await this.onButtonClick();
      this.isButtonLoading = false;
    }
  }

  onButtonHovered() {
    if (this.isDisable) return;
    this.isHovering = true;
  }
  onButtonUnhovered() {
    this.isHovering = false;
  }
}
